module.exports = __webpack_public_path__ + "img/ico_tab1_account@3x.cca89b06.png";